import Model from "./Model";
import SessionStructure from "./SessionStructure";
import moment from "moment";

export default class Session extends Model {

	constructor(props) {

		super({});

		this.setDefaultValues({
			id: null,
			token: null,
			type: null,
			session_structure: new SessionStructure(),
			start_date: null,
			end_date: null,
		}, props);
	}

	getName() {
		return this.session_structure.strategy ? this.session_structure.strategy.name : this.session_structure.component.name;
	}

	getIcon() {
		return this.session_structure.strategy ? this.session_structure.strategy.icon || 'mdi-strategy' : this.session_structure.component.icon || 'mdi-cube';
	}

	getColor() {
		return this.session_structure.strategy ? this.session_structure.strategy.color : this.session_structure.component.color;
	}

	getEvent(element, dataset) {
		const start = moment(this.start_date);
		const end = moment(this.end_date);
		return {
			id: this.id,
			dataset: dataset,
			element_id: element.id,
			duration: parseFloat(this.getDuration().asMinutes().toFixed(1)),
			startTime: start.format('HH:mm:ss'),
			endTime: this.end_date ? end.format('HH:mm:ss') : null,
			startDay: start.format('YYYY-MM-DD'),
			endDay: this.end_date ? end.format('YYYY-MM-DD') : null,
			start: start.format('YYYY-MM-DD HH:mm:ss'),
			end: this.end_date ? end.format('YYYY-MM-DD HH:mm:ss') : null,
			valid: true,
		}
	}

	getDuration() {
		return moment.duration(moment(this.end_date).diff(this.start_date));
	}
}
